var React = require('react');

function SymbolCommunityInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"29","cy":"100","r":"29","fill":"#4F6BFF","key":0}),React.createElement("circle",{"cx":"97","cy":"29","r":"29","fill":"#4F6BFF","key":1}),React.createElement("circle",{"cx":"29","cy":"29","r":"29","fill":"#ABC3FF","key":2}),React.createElement("circle",{"cx":"97","cy":"100","r":"29","fill":"#ABC3FF","key":3})]);
}

SymbolCommunityInline.defaultProps = {"width":"199","height":"199","viewBox":"-36.5 -35 199 199","fill":"none"};

module.exports = SymbolCommunityInline;

SymbolCommunityInline.default = SymbolCommunityInline;
